export { default } from './SectionCarouselCollectionsContainer';
